export const getFlagValue = (flags, flagKey, overrideKey) => {
	let urlParams = {};
	if (typeof window?.DDC?.getUrlParams === 'function') {
		urlParams = window.DDC.getUrlParams();
	}

	const finalizedValue = urlParams[overrideKey]
		? urlParams[overrideKey]
		: flags[flagKey];

	if (['true', 'false'].includes(finalizedValue)) {
		return finalizedValue === 'true';
	}

	return finalizedValue;
};
